import React from 'react';
import styles from './style.scss';

export function DateTimeDisplay({ showStart, showEnd, momentStartLocale, momentEndLocale, format, className }) {
  return (
    <div className={`date ${className}`}>
      <div className={styles.timeContainer}>
        {showStart && <div>{momentStartLocale.format(`${format}`)}</div>}
        {showStart && showEnd && <div style={{ margin: '0 5px' }}>-</div>}
        {showEnd && <div>{momentEndLocale.format(`${format}`)}</div>}
      </div>
    </div>
  );
}
